import styled from "@emotion/styled";
import {
  DatePicker,
  Form,
  Modal,
  Select,
  Spin,
  Table,
  Tooltip,
  message,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
// Redux
import { CALL_API } from "common/API";
import COLORS from "common/Colors";
import { STATUS_CODE } from "common/Constants";
import { concat, filter } from "lodash";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getStatusListFromID,
  getUserRoleId,
  getSelectedDepartmentId,
  getUserInfo,
  getMenuList,
} from "redux/selectors";
import {
  addDaysinDate,
  getKenyanDateTime,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import { useTranslation } from "react-i18next";
import { EyeFilled, BellFilled } from "@ant-design/icons";
import { ButtonFilled } from "reusableComponent/UIButtons";
import { toggleProcessingModal, toggleSuccessModal } from "redux/actions";
import RejectReasonModal from "molecules/RejectReasonModal";
import download from "downloadjs";
import ViewDocument from "reusableComponent/Popup/viewDocument";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    max-height: 500px;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 10px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.GREY};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding-bottom: 10px;
  }
  .ant-modal-footer {
    display: none;
  }
`;

function LeaveList({
  isModalVisible,
  closeModal,
  date,
  status_id,
  department_id,
  statusListFromID,
  allDepartmentList,
  userRoleId,
  ClientId,
  selectedDepartmentId,
  tabId,
  getLeaveLists,
}) {
  const dispatch = useDispatch();
  console.log("statusid--->", status_id);
  const { t } = useTranslation();
  const userInfo = useSelector(getUserInfo);
  console.log("selected deapartment id--->", selectedDepartmentId);
  console.log("statusListFromID---->", statusListFromID);
  const menuList = useSelector(getMenuList);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const [displayDeclineReasonModal, toggleDeclineReasonModalVisibility] =
    useState(false);

  const higherOfficialsEmailId = userInfo?.higherOfficialsList
    ?.filter((item) => item?.role === "CEO" || item?.role === "HR")
    ?.map((item) => item?.email);

  const isHigherOfficials = !!higherOfficialsEmailId?.includes(
    userInfo?.userid
  );

  // The logged-in user is the level 1 approver (reporting manager) of this leave.
  const isLevel1Approver = (record) =>
    !!record?.reporting_manager &&
    record?.reporting_manager === userInfo?.userid;

  const isLevel1Approved = (record) => {
    const isAmended =
      record?.having_cancel_request === "1" ||
      record?.having_cancel_request === 1;
    return isAmended
      ? !!record?.new_approved_rejected_byName
      : !!record?.approved_rejected_byName;
  };

  const [form] = Form.useForm();
  const [leaveList, setLeaveList] = useState([]);
  const [displayTableSpinner, toggleTableSpinner] = useState(false);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [displayLeaveModal, toggleDisplayLeaveModal] = useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [preview, setPreview] = useState(false);
  const [previewURL, setPreviewURL] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (date && status_id) {
      form.setFieldsValue({
        start_date: momentDate(date),
        end_date: momentDate(date),
        status_id,
        department_id: "",
      });
      getLeaveList();
      setSelectedLeaveType(status_id);
    }
  }, [isModalVisible]);

  useEffect(() => {
    getLeaveList();
  }, [
    form.getFieldValue("end_date"),
    form.getFieldValue("start_date"),
    form.getFieldValue("status_id"),
    form.getFieldValue("department_id"),
    date,
  ]);

  const confirmOperation = (statusId, leaveData) => {
    // A "5" (approve) request should only fully close the leave when the
    // higher official (Level 2) approves. A Level 1 approver's click keeps
    // the leave at status "4" (pending) so it surfaces for Level 2 approval.
    const resolvedStatusId =
      statusId === "5" ? (isHigherOfficials ? "5" : "4") : statusId;

    Modal.confirm({
      icon: "",
      content: t(
        `Are you sure you want to ${
          statusId === "5" ? "approve" : statusId === "6" ? "decline" : "cancel"
        } leave?`
      ),
      okText: t("YES"),
      cancelText: t("No"),
      onOk: async () => {
        // When the same user is both the level 1 and level 2 approver, record
        // the level 1 approval first, then give the final level 2 approval.
        if (
          resolvedStatusId === "5" &&
          isLevel1Approver(leaveData) &&
          !isLevel1Approved(leaveData)
        ) {
          const level1Code = await approveRejectCancelLeave(
            "4",
            "",
            leaveData,
            true
          );
          if (level1Code !== STATUS_CODE.SUCCESS) return;
        }
        await approveRejectCancelLeave(resolvedStatusId, "", leaveData);
      },
    });
  };

  const approveRejectCancelLeave = async (
    statusId,
    declined_reason = "",
    leaveData = leaveDetails,
    isIntermediateStep = false
  ) => {
    const {
      user_leave_id,
      start_date,
      end_date,
      having_cancel_request,
      new_start_date,
      new_end_date,
    } = leaveData;

    const payload = {
      userid: leaveData?.userid,
      user_leave_id,
      status_id: statusId,
      declined_reason,
      is_cancel_request: having_cancel_request === "1",
      start_date: getMySqlDate(new_start_date ? new_start_date : start_date),
      end_date: getMySqlDate(new_end_date ? new_end_date : end_date),
      approved_rejected_by_higherofficials: isHigherOfficials
        ? userInfo?.fullname
        : "",
    };

    console.log("payload --->", payload);

    const { code } = await CALL_API(
      `approve-reject-cancel-leave/${ClientId}`,
      "post",
      payload
    );

    // Level 1 step of a combined approval; the level 2 call follows.
    if (isIntermediateStep) {
      if (code !== STATUS_CODE.SUCCESS)
        message.error(t("Something went wrong. Please try again."));
      return code;
    }

    if (code === STATUS_CODE.SUCCESS) {
      dispatch(toggleProcessingModal(false));
      if (code === STATUS_CODE.SUCCESS) {
        // status_id "4" is a Level 1 (Reporting Manager) approval and "5" is a
        // Level 2 (higher official) approval - both are "approve" actions from
        // the user's point of view, even though only "5" fully closes the leave.
        // Only "6" is a decline; anything else here is treated as a cancellation.
        const isApproveAction = statusId === "4" || statusId === "5";

        const cancelRequestMessage = `Leave amendment request has been ${
          isApproveAction ? "approved" : "declined"
        }.`;

        // dispatch(
        //   toggleSuccessModal({
        //     visibility: true,
        //     message:
        //       having_cancel_request === "1"
        //         ? true
        //         : false
        //         ? cancelRequestMessage
        //         : t(
        //             `Leave has been ${
        //               statusId === "5"
        //                 ? "approved"
        //                 : statusId === "6"
        //                 ? "declined"
        //                 : "cancelled"
        //             } successfully.`
        //           ),
        //   })
        // );
        message.success(
          having_cancel_request === "1"
            ? cancelRequestMessage
            : `Leave has been ${
                isApproveAction
                  ? "approved"
                  : statusId === "6"
                  ? "declined"
                  : "cancelled"
              } successfully.`
        );
      } else {
        message.error(t("Something went wrong. Please try again."));
      }
      getLeaveLists();
    }
  };

  const setLeaveDetailsAsync = (value) =>
    new Promise((resolve) => {
      setLeaveDetails(value);
      resolve();
    });

  const handlePreviewClick = async (data) => {
    try {
      const preview = data?.fileName?.split(".")?.pop();
      setLoading(true);

      const { code, url } = await CALL_API(
        `document-list/${ClientId}`,
        "post",
        {
          user_leave_id: data?.user_leave_id,
          method: "file",
          userId: data?.userid,
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(preview)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
          setPreview(false);
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
      width: "20%",
      align: "center",
    },
    {
      title: t("Department"),
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
      align: "center",
    },
    {
      title: t("Start Date"),
      dataIndex: "start_date",
      key: "start_date",
      width: "15%",
      align: "center",
      render: (_, record) => {
        if (
          record.new_start_date === null ||
          record.new_start_date === "null" ||
          record.new_start_date === ""
        ) {
          return moment(record.start_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_start_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("End Date"),
      dataIndex: "end_date",
      key: "end_date",
      width: "15%",
      align: "center",
      render: (_, record) => {
        if (
          record.new_end_date === null ||
          record.new_end_date === "null" ||
          record.new_end_date === ""
        ) {
          return moment(record.end_date).format("DD MMM YYYY");
        } else {
          return moment(record.new_end_date).format("DD MMM YYYY");
        }
      },
    },
    {
      title: t("Leave Type"),
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "15%",
      align: "center",
    },
    {
      title: t("Days"),
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "10%",
      align: "center",
      render: (_, record) => {
        if (
          record.new_number_of_days === null ||
          record.new_number_of_days === "null" ||
          record.new_number_of_days === ""
        ) {
          return record.number_of_days;
        } else {
          return record.new_number_of_days;
        }
      },
    },
    {
      title: t("Attachment"),
      dataIndex: "fileName",
      key: "fileName",
      width: 150,
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            className="text-wrap"
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record);
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: t("Reliever Name"),
      dataIndex: "relievername",
      key: "relievername",
      width: "10%",
      render: (text) => {
        return text ? text : "-";
      },
    },
  ];

  if (
    (userRoleId === 1 && selectedLeaveType === 4) ||
    (userRoleId === 6 && selectedLeaveType === 4)
  ) {
    columns.push({
      title: t("Amended Leave"),
      dataIndex: "having_cancel_request",
      key: "having_cancel_request",
      align: "center",
      width: "10%",
      render: (having_cancel_request) =>
        having_cancel_request === 1 ? t("Yes") : t("No"),
    });
  }

  if (selectedLeaveType === "5" || selectedLeaveType === 5) {
    columns.push(
      {
        title: t("Level 1 Approved by"),
        dataIndex: "approved_rejected_byName",
        key: "approved_rejected_byName",
        align: "center",
        width: "10%",
        render: (_, record) => {
          const isAmended =
            record?.having_cancel_request === "1" ||
            record?.having_cancel_request === 1;

          // Amended leaves track their own Level 1 approval separately so the
          // original leave's approval isn't shown/overwritten.
          const approverName = isAmended
            ? record?.new_approved_rejected_byName
            : record?.approved_rejected_byName;

          return approverName ? approverName : "-";
        },
      },
      {
        title: t("Level 2 Approved by"),
        dataIndex: "approved_rejected_by_higherofficials",
        key: "approved_rejected_by_higherofficials",
        align: "center",
        width: "10%",
        render: (_, record) => {
          const isAmended =
            record?.having_cancel_request === "1" ||
            record?.having_cancel_request === 1;

          // Amended leaves track their own Level 2 approval separately so the
          // original leave's approval isn't shown/overwritten.
          const approverName = isAmended
            ? record?.new_approved_rejected_by_higherofficials
            : record?.approved_rejected_by_higherofficials;

          return approverName ? approverName : "-";
        },
      }
    );
  }

  if (
    status_id === "4" &&
    Menulist?.find(
      (item) =>
        item.access === true &&
        item.path === "allapprovals" &&
        item.subMenu?.some(
          (sub) => sub?.path === "approvals" && sub?.permission?.edit === true
        )
    )
  ) {
    columns.push({
      title: t("Action"),
      dataIndex: "address",
      key: "address",
      width: "10%",
      render: (_, record) => {
        const isAmended =
          record?.having_cancel_request === "1" ||
          record?.having_cancel_request === 1;

        // Amended leaves are approved/rejected using their own new_* fields,
        // independent of the original leave's approval state.
        const level1Approved = isAmended
          ? !!record?.new_approved_rejected_byName
          : !!record?.approved_rejected_byName;

        const level2Approved = isAmended
          ? !!record?.new_approved_rejected_by_higherofficials
          : !!record?.approved_rejected_by_higherofficials;

        // A higher official who is also this leave's reporting manager can
        // approve before level 1 approval (they are the level 1 approver).
        const canApprove =
          (!level1Approved &&
            (!isHigherOfficials || isLevel1Approver(record))) ||
          (isHigherOfficials && level1Approved && !level2Approved);

        return (
          <>
            <ButtonFilled
              type="primary"
              onClick={() => {
                setLeaveDetails(record);

                setTimeout(() => {
                  toggleDeclineReasonModalVisibility(true);
                  closeModal();
                }, 100);
              }}
            >
              {t("Decline")}
            </ButtonFilled>

            {canApprove ? (
              <ButtonFilled
                type="primary"
                onClick={() => {
                  setLeaveDetails(record);

                  setTimeout(() => {
                    confirmOperation("5", record);
                    closeModal();
                  }, 100);
                }}
              >
                {t("Approve")}
              </ButtonFilled>
            ) : (
              <span>
                {isHigherOfficials
                  ? t("Pending by level 1 approval")
                  : t("Pending by level 2 approval")}
              </span>
            )}
          </>
        );
      },
    });
  }

  const remindSuperior = (leaveRecord) => {
    const { confirm } = Modal;
    confirm({
      icon: "",
      content: t(
        "Do you Want to send reminder notification to HOD & Assistant HOD?"
      ),
      async onOk() {
        const { user_leave_id, user_id } = leaveRecord;
        const { code } = await CALL_API(
          "leave-notification-to-hod-assistant-hod",
          "post",
          { user_leave_id, user_id }
        );
        if (code === STATUS_CODE.SUCCESS) {
          message.success(t("Notification has been sent."));
        } else {
          message.error(t("Something went wrong. Please try again."));
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const getLeaveList = async () => {
    const { status_id, start_date, end_date, department_id } =
      form.getFieldsValue();
    setSelectedLeaveType(status_id);
    toggleTableSpinner(true);
    const payload = {
      status_id: "4,5",
      department_id: [""],
      selected_role_id: "0",
      start_date: getMySqlDate(start_date),
      end_date: getMySqlDate(end_date),
    };
    if (tabId === t("My Team")) {
      payload.reportingmanager = userInfo?.userid;
    }
    const { code, leaves } = await CALL_API(
      `leave-list/${ClientId}`,
      "post",
      payload
    );
    toggleTableSpinner(false);
    if (code === STATUS_CODE.SUCCESS) {
      if (status_id === "4") {
        const filteredData = leaves.filter(
          (category) =>
            category.status_id === "4" ||
            (category.status_id === "5" &&
              category.having_cancel_request === "1")
        );
        setLeaveList(
          tabId === t("Mine")
            ? filteredData?.filter((item) => item.userid === userInfo?.userid)
            : filteredData
        );
      } else {
        const filteredData = leaves.filter(
          (category) =>
            category.status_id === "5" && category.having_cancel_request !== "1"
        );
        setLeaveList(
          tabId === t("Mine")
            ? filteredData?.filter((item) => item.userid === userInfo?.userid)
            : filteredData
        );
      }
    }
  };

  const restrictPastDate = (current, element) => {
    let customDate = momentDate().format("YYYY-MM-DD");
    if (element === "end_date") {
      return current < moment(form.getFieldValue("start_date"));
    }
    return current && current < moment(customDate, "YYYY-MM-DD");
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const closeDeclineReasonModal = async (reason) => {
    closeModal();
    if (reason) await approveRejectCancelLeave("6", reason);
    toggleDeclineReasonModalVisibility(false);
  };

  return (
    <>
      <StyledModal
        title=""
        visible={isModalVisible}
        onCancel={closeModal}
        width="75%"
        footer={[]}
      >
        <div>
          <Form
            form={form}
            name="leavelist_form"
            layout="inline"
            initialValues={{
              status_id: "",
              start_date: momentDate(getKenyanDateTime()),
              end_date: momentDate(addDaysinDate(getKenyanDateTime(), 7)),
              department_id: "",
            }}
            onFinish={getLeaveList}
          >
            <Form.Item
              name="status_id"
              rules={[{ required: true, message: "" }]}
            >
              <Select
                placeholder={t("Select...")}
                items={statusListFromID}
                fieldNames={{
                  label: "status_name",
                  value: "status_id",
                }}
                options={statusListFromID}
                disabled={true}
              />
            </Form.Item>

            <Form.Item
              name="start_date"
              rules={[
                () => ({
                  validator(rule, value) {
                    const date = moment(value);
                    return date.isValid()
                      ? Promise.resolve()
                      : Promise.reject();
                  },
                }),
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                placeholder={t("Start date")}
                disabledDate={(current) =>
                  restrictPastDate(current, "start_date")
                }
                onChange={validateDateRange}
                allowClear={false}
              />
            </Form.Item>

            <Form.Item
              name="end_date"
              rules={[
                () => ({
                  validator(rule, value) {
                    const date = moment(value);
                    return date.isValid()
                      ? Promise.resolve()
                      : Promise.reject();
                  },
                }),
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                placeholder={t("End date")}
                disabledDate={(current) =>
                  restrictPastDate(current, "end_date")
                }
                onChange={validateDateRange}
                allowClear={false}
              />
            </Form.Item>
          </Form>

          <Spin spinning={displayTableSpinner || loading}>
            <StyledTable
              dataSource={leaveList}
              columns={columns}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="user_leave_id"
              pagination={false}
            />
          </Spin>
        </div>
      </StyledModal>
      <RejectReasonModal
        isOpenModal={displayDeclineReasonModal}
        closeModal={closeDeclineReasonModal}
      />
      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  statusListFromID: getStatusListFromID(state, ["4", "5", "6"]),
  allDepartmentList: getAllDepartmentList(state),
  ClientId: getClientid(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
});

export default connect(mapStateToProps, null)(LeaveList);
